import AppLoader from '@/components/AppLoader';
import {
	ROUTE_DASHBOARD_ACCEPT_INVITE_LEGACY_PAGE,
	ROUTE_DASHBOARD_ACCEPT_INVITE_PAGE,
	ROUTE_DASHBOARD_HOME,
	ROUTE_MICROSOFT_REDIRECT,
	ROUTE_ONBOARDING_USERNAME,
} from '@/constants/routes';
import useAuth from '@/hooks/useAuth';
import clientStateService from '@/services/clientState.service';
import RequireAuth from '@/utils/RequireAuth';
import { Box } from '@chakra-ui/react';
import { Suspense } from 'react';
import { Redirect, Route, Switch, useLocation, useParams } from 'react-router-dom';
import { MicrosoftOauthRedirect } from './MicrosoftOauthRedirect/MicrosoftOauthRedirect';
import HomePage from './home/home.router';

export default RequireAuth(function DashboardRouter() {
	const { getCurrentUser, status } = useAuth();
	const location = useLocation();

	if (status === 'pending') {
		return <AppLoader />;
	}

	if (!clientStateService.decode(getCurrentUser().clientState).ob && location.pathname !== ROUTE_MICROSOFT_REDIRECT) {
		return <Redirect to={ROUTE_ONBOARDING_USERNAME} />;
	}

	return (
		<Suspense fallback={<AppLoader />}>
			<Box h="100dvh" w="100dvw" overflow="hidden" display="grid">
				<Switch>
					<Route path={ROUTE_DASHBOARD_HOME}>
						<HomePage />
					</Route>

					<Route strict path={ROUTE_MICROSOFT_REDIRECT}>
						<MicrosoftOauthRedirect />
					</Route>

					<Route exact path={ROUTE_DASHBOARD_ACCEPT_INVITE_LEGACY_PAGE}>
						<RedirectToNewPage />
					</Route>

					<Redirect to={ROUTE_DASHBOARD_HOME} />
				</Switch>
			</Box>
		</Suspense>
	);
});

/**
 * TODO: Ensure this URL is not used anymore
 */
function RedirectToNewPage() {
	const { id } = useParams<{ id: string }>();
	return <Redirect to={ROUTE_DASHBOARD_ACCEPT_INVITE_PAGE.replace(':id', id)} />;
}
